import { useMemo } from "react";

import { useUser } from "@/context/UserProvider";

const EMPTY_LEGISLATION_MONITOR_STATES: string[] = [];

export function useLegislationMonitorStates(): string[] {
  const { currentUser } = useUser();
  const abbreviations = currentUser?.legislation_monitor_state_abbreviations;
  const statesKey = abbreviations?.join(",") ?? "";

  return useMemo(
    () => abbreviations ?? EMPTY_LEGISLATION_MONITOR_STATES,
    [statesKey],
  );
}
